import { APPOINTMENT_STATUSES, APPOINTMENT_TYPES } from 'features/order-tracker/utils/entries';
import { CONTACT_US_INFO_TYPE } from 'features/order-tracker/utils/entries/contactUsInfoType';

// eslint-disable-next-line no-unused-vars
import { AppointmentStrategy } from './AppointmentStrategy';

export class BookedAppointmentStrategy implements AppointmentStrategy {
  getInfoType = (_appointment: common.EngineerAppointment, isAuthenticated: boolean): common.ContactUsInfo | null =>
    isAuthenticated ? null : CONTACT_US_INFO_TYPE.AmendmentDisabled;

  isReminderAvailable = (): boolean => false;

  isSiteContactAvailable = (appointment: common.EngineerAppointment): boolean => !!appointment.siteContact;

  isAmendable = (): boolean => false;

  isApplicable = (appointment: common.EngineerAppointment): boolean =>
    APPOINTMENT_STATUSES.Booked === appointment.status && APPOINTMENT_TYPES.expert !== appointment.type;

  isHelpSectionAvailable = (): boolean => false;
}
